var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.step,{tag:"component",attrs:{"account":_vm.account,"import-job-id":_vm.importJobId,"settings":_vm.settings},on:{"change:step":_vm.goto,"track:job":_vm.trackImportJob,"complete":_vm.complete,"change:setting":_vm.changeSetting,"clear:settings":_vm.clearSettings}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }